// @ts-strict-ignore
import React from 'react';
import some from 'lodash/some';

import {LabelTheme, SectionItem} from 'common/components/items-menu/types';
import {OTHER_SEGMENT_VALUE} from 'common/report/insights/util/constants';
import {colors} from 'common/util/colors';
import {ChartLegendReact} from 'common/components/chart-legend';
import {ChartLegendTheme} from 'common/components/chart-legend/constants';
import {SegmentFilterController} from 'common/charts/contexts/segment-filter-controller';
import {useMeasure} from 'common/hooks/useMeasure';

const getMaxLegendItemsForOneRow = (availableWidth: number): number => {
  if (availableWidth < 256) {
    return 2;
  }
  if (availableWidth < 512) {
    return 3;
  }
  if (availableWidth < 768) {
    return 5;
  }
  if (availableWidth < 1024) {
    return 6;
  }
  if (availableWidth < 1280) {
    return 7;
  }
  if (availableWidth < 1536) {
    return 8;
  }
  if (availableWidth < 1792) {
    return 9;
  }

  return 10;
};

interface SegmentLegendHeaderProps {
  className?: string;
  segmentFilterController?: SegmentFilterController;
  visibleSegmentIds?: string[];
}

export function SegmentLegendHeader(props: SegmentLegendHeaderProps) {
  const [containerRef, {width}] = useMeasure();

  const visibleSegmentItems = props.segmentFilterController.getDisplayedItems(0);
  let legendItems: Array<SectionItem<string>> = visibleSegmentItems.map((segmentItem) => {
    // special case to show different color in header vs segment-filter
    const color =
      segmentItem.id === OTHER_SEGMENT_VALUE
        ? colors.otherSegment.primary
        : props.segmentFilterController.getItemColor(0, segmentItem.id);

    return {
      label: segmentItem.label,
      value: segmentItem.id,
      isSelected: true,
      labelTheme: LabelTheme.Soft,
      wrapLabel: true,
      color,
    };
  });

  if (props.visibleSegmentIds) {
    legendItems = legendItems.filter((item) =>
      some(props.visibleSegmentIds, (segmentId) => {
        return segmentId === item.value;
      }),
    );
  }

  const maxLegendItems = getMaxLegendItemsForOneRow(width);
  /** @todo (colors) this component is simply clamping the number of visible legend items
   * this can live inside ChartLegend to avoid this added level of indirection and confusion
   * as to which legend component to use
   */
  return (
    <ChartLegendReact
      ref={containerRef}
      className={props.className}
      loading={!props.segmentFilterController.hasLoaded()}
      maxLegendItems={maxLegendItems}
      // -2px to account for gap
      maxTableItemWidth={`calc(${Math.floor(100 / Math.min(maxLegendItems, legendItems.length || 1))}% - 2px)`}
      sections={[{items: legendItems}]}
      theme={ChartLegendTheme.CardTable}
    />
  );
}
